import { ServiceContractParam } from 'api/types/params';
import { isFinanceProject } from 'config';

import { ServiceContractFormType } from '../../forms/serviceContractForm';

export const parseServiceContractParam = (
  data: ServiceContractFormType
): ServiceContractParam => {
  const isFinance = isFinanceProject();

  return {
    conclusionDate: data.serviceContract.conclusionDate,
    number: data.serviceContract.number,
    terminationDate: data.serviceContract.terminationDate,
    type: data.serviceContract.type?.value,
    fileId_Finance: isFinance
      ? data.serviceContract.document_Finance?.[0]?.id
      : undefined,
  };
};
